export enum CourseRouteTypeEnum {
  Shuttle = "Shuttle",
  Flex = "Flex",
  JoinConnection = "JoinConnection",
  SplitConnection = "SplitConnection",
  Combined = "Combined",
}
